var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotionDetectorSensor({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.3,3.2c1.5,0.5,2.5,1.8,2.5,3.3c0.2,1.7-0.7,3.3-2.3,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.1,3.2c1.7,0.2,2.9,2.2,2.8,4.2c-0.1,1.4-1,2.7-2.4,3.2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.6,
    className: "st0",
    width: 13,
    height: 12.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 13.2,
    className: "st0",
    width: 13,
    height: 2.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionDetectorSensor);
export default __webpack_public_path__ + "static/media/MotionDetectorSensor.ba95afd5f8acfec0a4eb8713ce3d4edd.svg";
export { ForwardRef as ReactComponent };